
type Props = {
  number: number;
  textColor?: string;
  fontSize?: string;
  bgColor?: string;
  className?: string;
  size?: string;
};

export function NumberCount({
  number,
  className,
  textColor = 'text-white',
  bgColor = 'bg-red-400',
  size = 'w-6',
  fontSize = 'text-xs',
}: Props) {
  return !!number ? (
    <div
      className={`inline-flex items-center justify-center aspect-square rounded-full
			${size} ${textColor} ${bgColor} ${fontSize} ${className}`}
    >
      <p>{number > 99 ? '99+' : number}</p>
    </div>
  ) : (
    <></>
  );
}
